export const networksList = {
  ListOfNetworks: [
    'Cigna TTK',
    'Fortis',
    'Jeevan Rekha Critical Care and Trauma Hospital',
    'Siddham ENT Centre LLP',
    'Dhanvantri Life Care Pvt. Ltd',
    'Metro Mas Heart Care and MultiSpeciality Hospital',
    'Eternal Heart Care Center and Research Institute',
  ],
};

export const doctorTypesList = {
  Pagination: {
    PageSize: 10,
    PageNumber: 1,
    TotalRecords: 100,
  },
  ListOfDoctorTypes: [
    'Anatomical Pathology',
    'Anesthesiology',
    'Cardiology',
    'Cardiovascular/Thoracic Surgery',
    'Clinical Immunology/Allergy',
    'Dermatology',
    'Diagnostic Radiology',
    'Emergency Medicine',
    'Family Medicine',
    'Gastroenterology',
  ],
};

const singleDoctorRecord = {
  OID: 'ABCD1234564542',
  FirstName: 'Victoria',
  MiddleName: '',
  LastName: 'Reise',
  DoctorTitle: 'Dr.',
  NameSuffix: 'MD',
  Gender: 'Male',
  AvatarOid: 'AvatarOID',
  Specialities: ['Periodontist', 'Prosthodontist', 'Endodontists'],
  Credentials: ['Test Credential 1', 'Test Credential 2'],
  Experience: '10 years',
  AcceptingNewPatients: false,
  Address: {
    AddressLine1: '6890 Mount toll Ct',
    AddressLine2: '',
    AddressLine3: '',
    PostalCode: '80913',
    City: 'Colorado',
    State: '',
    County: '',
    Coordinates: '',
    Distance: 10,
  },
  SpokenLanguages: ['English', 'Chinese'],
  Phone: '(719) 632-5700',
  InNetwork: true,
  BoardCertificate: 'International Medicine | Gastroenterology',
  Education: 'University of Nebraska Med Ctr Phy Asst Prg, 2008',
};

export const searchDoctorsResults = {
  Pagination: {
    PageSize: 10,
    PageNumber: 1,
    TotalRecords: 100,
  },
  SearchDoctors: Array(20).fill(singleDoctorRecord),
};

export const doctorDetails = {
  DoctorDetails: {
    OID: 'ABCD123456',
    FirstName: 'Victoria',
    MiddleName: 'Jacob',
    LastName: 'Reise',
    DoctorTitle: 'Dr.',
    Gender: 'Female',
    AvatarOid: '',
    Age: 30,
    Specialities: ['Periodontist', 'Prosthodontist', 'Endodontists'],
    Credentials: [],
    Experiance: '3 years',
    LicenseType: 'Medical Doctor, MD',
    MedicalSchoolEducation:
      'Medical School: University of Nebraska Med Ctr Phy Asst Prg , 2008',
    AwardsAndRecognition: '',
    LicenseNumber: 'A 00052385',
    ProviderId: '1861446841',
    Address: [
      {
        AddressLine1: 'address line 1',
        AddressLine2: 'address line 2',
        AddressLine3: 'address line 3',
        PostalCode: '302020',
        City: 'New York',
        State: 'State of New York',
        County: 'Manhattan',
        AcceptingNewPatients: false,
        PatientSatisfaction: null,
        SameDayAppointment: true,
        Coordinateds: '',
        Distance: 10,
        FacilitiesAtLocation: ['Drinking Water', 'Free Parking'],
      },
    ],
  },
  SpokenLanguages: ['English', 'Chinese', 'Spanish'],
  Phone1: '999-999 2292',
  Phone2: '999-999 2293',
  EmailAddress: 'someemail@email.com',
  Website: 'www.somewebsite.com',
  InNetwork: true,
  BoardCertifications: ['Board certification 1', 'Board certification 2'],
  Education: {
    type: 'string',
  },
  Affiliations: [
    {
      OID: 'AFFILIATION-OID-001',
      HospitalName: 'Star Health Care',
      HospitalAddress: 'Star health care address',
    },
  ],
  MedicalGroup: [
    {
      OID: 'MEDICAL-GROUP-OID1',
      MedicalGroupName: 'Medical Group Name',
      PCPEnrollmentId: 'PCP-ENROLL-ID1',
    },
  ],
  OfficeHours: [
    {
      Day: 'Sunday',
      Time: '11:00 AM - 04:30 PM',
    },
    {
      Day: 'Monday',
      Time: '11:00 AM - 08:30 PM',
    },
    {
      Day: 'Tuesday',
      Time: '11:00 AM - 08:30 PM',
    },
    {
      Day: 'Wednesday',
      Time: '11:00 AM - 08:30 PM',
    },
    {
      Day: 'Thursday',
      Time: '11:00 AM - 08:30 PM',
    },
    {
      Day: 'Friday',
      Time: '11:00 AM - 08:30 PM',
    },
    {
      Day: 'Saturday',
      Time: 'Closed',
    },
  ],
};
